import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import KeyCodes from '../../utils/KeyCodes';
import ParticipantStatus from '../../domain/ParticipantStatus';
import QrReader from 'react-qr-reader';

const ParticipantComputedStatus = {
    NAO_CADASTRADO: 'NAO_CADASTRADO',
    PENDENTE: 'PENDENTE',
    CADASTRADO: 'CADASTRADO',
    CADASTRADO_SEM_CRACHA: 'CADASTRADO_SEM_CRACHA',
    CADASTRADO_SEM_APOSTILA: 'CADASTRADO_SEM_APOSTILA',
};

function getComputedStatus(participant, hasLinkCourseware) {
    if (!participant) {
        return ParticipantComputedStatus.NAO_CADASTRADO;
    } else if (participant.status !== ParticipantStatus.OK) {
        return ParticipantComputedStatus.PENDENTE;
    } else if (hasLinkCourseware && participant.coursewareId === null) {
        return ParticipantComputedStatus.CADASTRADO_SEM_APOSTILA;
    } else if (participant.badge === false) {
        return ParticipantComputedStatus.CADASTRADO_SEM_CRACHA;
    } else { // if (participant.badge === true && participant.coursewareId !== null) {
        return ParticipantComputedStatus.CADASTRADO;
    }
}

class CredenciamentoDoEvento extends React.Component {
    constructor(props) {
        super(props);
	    this.handleQrScan = this.handleQrScan.bind(this);
    }

    handleQrError(e) {
        console.error(e);
    }

    handleQrScan(data) {
        if (null !== data && this.props.credenciamento.codigoApostila !== data) {
            const beepUrl = require('../../../resources/audio/scanner_beep.mp3');
            const snd = new Audio(beepUrl);
            snd.play();
            this.props.events.onUpdateText('codigoApostila', data);
        }
    }

    componentDidMount() {
        this.originalComputedStatus = this.computedStatus;
        $(this.inputCpf).mask('000.000.000-00');
        this.inputCpf.focus();
    }

    componentDidUpdate() {
        if (this.computedStatus !== this.originalComputedStatus) {
            this.originalComputedStatus = this.computedStatus;

            if (this.computedStatus === ParticipantComputedStatus.CADASTRADO_SEM_CRACHA)
                this.printBadge.focus();
            else if (this.computedStatus === ParticipantComputedStatus.CADASTRADO_SEM_APOSTILA)
                this.linkCourseware.focus();
            else
                this.inputCpf.focus();
        }
    }

    componentWillUnmount() {
        $(this.inputCpf).unmask();
    }

    render() {
        const validacao = this.props.credenciamento;
        const event = validacao.event;
        const events = this.props.events;
        const token = this.props.token;

        const hasLinkCourseware = event.linkCourseware;
        const cpf = validacao.cpf;
        const participant = validacao.participant;
        const usualName = validacao.usualName;
        const firstVerify = validacao.firstVerify;
        const executingVerifyCpf = validacao.executingVerifyCpf;
        const executingPrintBadge = validacao.executingPrintBadge;
        const executingLinkCourseware = validacao.executingLinkCourseware;
        const computedStatus = firstVerify ? undefined : getComputedStatus(participant, hasLinkCourseware);

        this.computedStatus = computedStatus;

        const codigoApostila = validacao.codigoApostila;

        const onCodigoApostilaChanged = (e) => events.onUpdateText('codigoApostila', e.target.value);

        const onCodigoApostilaKeyDown = (e) => {
            if (e.keyCode === KeyCodes.ENTER && codigoApostila && codigoApostila.length > 0)
                return onLinkCoursewareAndPrintBadge();

            if (e.keyCode === KeyCodes.ESCAPE)
                return events.onUpdateText('codigoApostila', '');
        };

        // const onCpfChanged = (e) => events.onUpdateText('cpf', e.target.value);
        const onCpfChanged = (e) => events.onUpdateText('cpf', $(this.inputCpf).cleanVal());

        const onCpfKeyDown = (e) => {
            if (e.keyCode === KeyCodes.ENTER && cpf && cpf.length > 0)
                return onVerifyCpf(e);

            if (e.keyCode === KeyCodes.ESCAPE)
                return events.onUpdateText('cpf', '');
        };

        const onUsualNameChanged = (e) => events.onUpdateText('usualName', e.target.value);

        const onUsualNameKeyDown = (e) => {
            if (e.keyCode === KeyCodes.ENTER && usualName && usualName.length > 0)
                return onPrintBadge();

            if (e.keyCode === KeyCodes.ESCAPE)
                return events.onUpdateText('usualName', '');
        };

        const onVerifyCpf = (e) => {
            e.preventDefault();
            events.onVerifyCpf(cpf, event, token);
        };

        const onPrintBadge = () => {
            if (usualName && usualName.length > 0)
                events.onPrintBadge(usualName, participant, event, token);
        };

        const onLinkCoursewareAndPrintBadge = () => {
            events.onLinkCourseware(participant, event, codigoApostila, token);
            onPrintBadge();
        };

        const panelHeader = computedStatus === ParticipantComputedStatus.NAO_CADASTRADO ?
            'Não encontrado' :
            (
                participant ?
                    (participant.name
                        + (participant.cpf ? '  -  CPF: ' + participant.cpf : '')
                        + (participant.pacote ? ' - Pacote: ' + participant.pacote : '')) :
                    ''
            );

        const buttonVerifyText = executingVerifyCpf === true ? 'Processando...' : 'Verificar';

        const buttonVerifyDisabled = executingVerifyCpf === true ? true : (cpf ? cpf.length === 0 : true);

        const buttonPrintText = executingPrintBadge === true ? 'Processando...' : 'Imprimir Crachá';

        const buttonPrintDisabled = executingPrintBadge === true;

        const buttonReprintText = executingPrintBadge === true ? 'Processando...' : 'Reimprimir Crachá';

        const buttonReprintDisabled = executingPrintBadge === true;

        const buttonLinkCoursewareText = executingLinkCourseware === true ? 'Processando...' : 'Associar Apostila & Imprimir Crachá';

        const buttonLinkCoursewareDisabled = executingLinkCourseware === true;

        const qrPreviewStyle = {
            height: 240,
            width: 320,
        };

        return (
            <div>
                <h4>Credenciamento de participante através do CPF</h4>

                <div className="row">
                    <div className="col-md-12">
                        <form className="form-horizontal" onSubmit={(e) => e.preventDefault()}>
                            <div className="form-group">
                                <div className="col-sm-10">
                                    <input type="text" className="form-control" placeholder="CPF"
                                           ref={(ref) => this.inputCpf = ref}
                                           value={cpf} onChange={onCpfChanged} onKeyDown={onCpfKeyDown} />
                                </div>
                                <div className="col-sm-2">
                                    <button type="button" className="btn btn-default btn-block"
                                            ref={(ref) => this.verifyCpf = ref}
                                            disabled={buttonVerifyDisabled}
                                            onClick={onVerifyCpf}>
                                        {buttonVerifyText}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <br />

                {computedStatus === ParticipantComputedStatus.NAO_CADASTRADO &&
                    <div className="panel panel-warning">
                        <div className="panel-heading">{panelHeader}</div>
                        <div className="panel-body">
                            Participante não cadastrado no evento.
                        </div>
                    </div>
                }

                {computedStatus === ParticipantComputedStatus.PENDENTE &&
                    <div className="panel panel-danger">
                        <div className="panel-heading">{panelHeader}</div>
                        <div className="panel-body">
                            Participante com pendências. Favor dirigir-se ao comercial.
                        </div>
                    </div>
                }

                {computedStatus === ParticipantComputedStatus.CADASTRADO_SEM_CRACHA &&
                    <div className="panel panel-default">
                        <div className="panel-heading">{panelHeader}</div>
                        <div className="panel-body">
                            Participante cadastrado no evento.{'  '}
                            <button className="btn btn-info" disabled={buttonPrintDisabled}
                                    ref={(ref) => this.printBadge = ref}
                                    onClick={onPrintBadge}>{buttonPrintText}</button>
                        </div>
                    </div>
                }

                {computedStatus === ParticipantComputedStatus.CADASTRADO_SEM_APOSTILA &&
                    <div className="panel panel-default">
                        <div className="panel-heading">{panelHeader}</div>
                        <div className="panel-body">
                            <form>
                                <div className="form-group">
                                    <label>Código da Apostila:</label>
                                    <input type="text" className="form-control" placeholder="00000000-0000-0000-0000-000000000000"
                                           value={codigoApostila} onChange={onCodigoApostilaChanged} onKeyDown={onCodigoApostilaKeyDown} />
                                </div>
                                <button className="btn btn-info" onClick={onLinkCoursewareAndPrintBadge}
                                        ref={(ref) => this.linkCourseware = ref}
                                        disabled={buttonLinkCoursewareDisabled}>{buttonLinkCoursewareText}</button>
                                <QrReader delay={100} onError={this.handleQrError} onScan={this.handleQrScan} style={qrPreviewStyle}/>
                            </form>
                        </div>
                    </div>
                }

                {computedStatus === ParticipantComputedStatus.CADASTRADO &&
                    <div className="panel panel-default">
                        <div className="panel-heading">{panelHeader}</div>
                        <div className="panel-body">
                            <form className="form-inline" onSubmit={(e) => e.preventDefault()}>
                                <div className="form-group">
                                    {hasLinkCourseware && <label style={{ fontWeight: 'normal', marginRight: 10 }}>Participante cadastrado com crachá impresso e apostila entregue.</label>}
                                    {!hasLinkCourseware && <label style={{ fontWeight: 'normal', marginRight: 10 }}>Participante cadastrado com crachá impresso.</label>}
                                    <input type="usualName" className="form-control" placeholder="Nome no Crachá" maxLength="15"
                                           value={usualName} onChange={onUsualNameChanged} onKeyDown={onUsualNameKeyDown} />
                                </div>
                                <button style={{ marginLeft: 10 }} className="btn btn-info" disabled={buttonReprintDisabled}
                                        onClick={onPrintBadge}>{buttonReprintText}</button>
                            </form>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

class Credenciamento extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const props = this.props;

        const app = props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.CREDENCIAMENTO)
            return null;

        const credenciamento = props.credenciamento;

        if (!credenciamento.event)
            return (
                <div>
                    <h2>Nenhum evento selecionado.</h2>
                    <h3>Consulte os administradores.</h3>
                </div>
            );

        return (
            <div>
                <h2>Evento:{' '}{credenciamento.event.name}</h2>
                {credenciamento.event && <CredenciamentoDoEvento {...this.props} />}
            </div>
        );
    }
}

export default Credenciamento;



// WEBPACK FOOTER //
// src/views/pages/Credenciamento.jsx